<template>
    <div>
        <div v-if="visible" class="modal-overlay" @click="closeModal">
            <div class="modal-content" @click.stop>
                <button class="close-btn" @click="closeModal">✖</button>

                <h2 class="modal-header">Logga in</h2>

                <div class="social-login">
                    <button class="social-btn google">
                        <img src="data:image/svg+xml,%3csvg%20viewBox='0%200%20533.5%20544.3'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M533.5%20278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1%2033.8-25.7%2063.7-54.4%2082.7v68h87.7c51.5-47.4%2081.1-117.4%2081.1-200.2z'%20fill='%234285f4'/%3e%3cpath%20d='M272.1%20544.3c73.4%200%20135.3-24.1%20180.4-65.7l-87.7-68c-24.4%2016.6-55.9%2026-92.6%2026-71%200-131.2-47.9-152.8-112.3H28.9v70.1c46.2%2091.9%20140.3%20149.9%20243.2%20149.9z'%20fill='%2334a853'/%3e%3cpath%20d='M119.3%20324.3c-11.4-33.8-11.4-70.4%200-104.2V150H28.9c-38.6%2076.9-38.6%20167.5%200%20244.4l90.4-70.1z'%20fill='%23fbbc04'/%3e%3cpath%20d='M272.1%20107.7c38.8-.6%2076.3%2014%20104.4%2040.8l77.7-77.7C405%2024.6%20339.7-.8%20272.1%200%20169.2%200%2075.1%2058%2028.9%20150l90.4%2070.1c21.5-64.5%2081.8-112.4%20152.8-112.4z'%20fill='%23ea4335'/%3e%3c/svg%3e"
                            alt="Google" height="22">
                        Fortsätt med Google
                    </button>
                    <button class="social-btn facebook">
                        <i class="fab fa-facebook"></i> Fortsätt med Facebook
                    </button>
                </div>

                <div class="divider">
                    <span>Eller</span>
                </div>

                <form class="login-form">
                    <div class="form-group">
                        <label for="email" class="form-label">Email*</label>
                        <input type="email" id="email" class="form-input" placeholder="Ange din e-post" />
                    </div>

                    <div class="form-group">
                        <label for="password" class="form-label">Lösenord*</label>
                        <div class="password-field">
                            <input type="password" id="password" class="form-input" placeholder="Ange ditt lösenord" />
                            <span class="toggle-password">👁️</span>
                        </div>
                    </div>
                    <div class="forgot-password">
                        <a href="#" @click.prevent="openForgotPassword">Glömt lösenord?</a>
                    </div>
                    <button type="submit" class="login-btn">Fortsätt med mial</button>

                    <div class="new-user">
                        <a href="#" @click.prevent="createAccount">Ny på Eventstaden? Skapa ett gratiskonto</a>
                    </div>

                </form>
            </div>
        </div>

    </div>

</template>

<script>

export default {
    name: "AccountModal",
    components: {},
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loginModal: true,
        }
    },
    methods: {
        openForgotPassword() {
            this.$emit('accounModal', { open: 'forgot-password' });
        },
        createAccount() {
            this.$emit('accounModal', { open: 'create-account' });
        },
        closeModal() {
            this.$emit('accounModal', { open: '' });
        },
    },
};
</script>

<style scoped>
/* Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

/* Modal Content */
.modal-content {
    background: #1a2b48;
    /* Dark blue background */
    color: white;
    width: 90%;
    max-width: 400px;
    border-radius: 10px;
    padding: 20px;
    position: relative;
    text-align: center;
}

/* Close Button */
.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    color: white !important;
    cursor: pointer;
}

/* Header */
.modal-header {
    margin-bottom: 20px;
}

/* Social Buttons */
.social-login {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.social-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
}

.social-btn.google {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: black;
    background-color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.social-btn i {
    font-size: 18px;
}

.social-btn.facebook {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    background: #147dc2 !important;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

/* Divider */
.divider {
    display: flex;
    align-items: center;
    margin: 20px 0;
}

.divider span {
    margin: 0 10px;
    color: #aaa;
    font-weight: 600;
}

.divider:before,
.divider:after {
    content: "";
    flex: 1;
    height: 2px;
    background: #444;
}

.forgot-password {
    display: flex;
    justify-content: flex-end;
    /* Aligns the content to the right */
}

.forgot-password a {
    color: #aaa;
    /* Matches the button/link color scheme */
    font-weight: 600;
    text-decoration: none;
    font-size: 14px;
    /* Adjust font size for better appearance */
    transition: color 0.3s;
    /* Adds smooth transition for hover effect */
}

.forgot-password a:hover {
    color: #444;
}

.new-user {
    color: #aaa;
    /* Matches the button/link color scheme */
    font-weight: 600;
    text-decoration: none;
    font-size: 14px;
    /* Adjust font size for better appearance */
    transition: color 0.3s;
    /* Adds smooth transition for hover effect */
}

.new-user a {
    color: #aaa;
}

.new-user a:hover {
    color: #444;
}

/* Login Form */
.login-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.login-form input {
    padding: 10px;
    border: none;
    border-radius: 5px;
    font-size: 14px;
}

.password-field {
    position: relative;
    width: 100%;
}

.password-field .toggle-password {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
}

/* Login Button */
.login-btn {
    background: #0044cc;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
}

.form-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* Aligns elements to the left */
    gap: 5px;
    /* Space between label and input */
}

/* Label styling */
.form-label {
    font-size: 14px;
    font-weight: bold;
    color: white;
    /* Matches the design */
    margin-bottom: 5px;
}

/* Input styling */
.form-input {
    padding: 10px;
    width: 100%;
    /* Full width */
    border: none;
    border-radius: 5px;
    font-size: 14px;
    box-sizing: border-box;
    /* Ensures padding doesn't affect width */
}
</style>